/**
 * Datos del negocio en un solo lugar.
 * Si cambia un teléfono, una dirección o un horario, se edita ACÁ y se
 * actualiza en todo el sitio (navbar, contacto, footer, WhatsApp y SEO).
 */

export const site = {
  name: "Riego Mercedes",
  legalName: "Riego Mercedes",
  tagline: "La solución a su requerimiento en tecnología de riego",
  url: "https://riegomercedes.com",

  // Teléfono en formato internacional, sin espacios ni guiones (para wa.me y tel:)
  phoneRaw: "5492657504891",
  phoneDisplay: "+54 9 2657 50-4891",

  email: "info@riegomercedes.com", // TODO: confirmar el email real de contacto

  address: {
    street: "Hipólito Yrigoyen 128",
    // TODO: verificar el código postal — "D57321FD" no tiene formato CPA válido.
    // El CPA de Villa Mercedes suele ser D5730 + 3 letras (ej. D5730ABC).
    postalCode: "D57321FD",
    city: "Villa Mercedes",
    region: "San Luis",
    country: "AR",
    // TODO: ajustar a las coordenadas exactas del local (Google Maps > click derecho
    // sobre el punto > copiar coordenadas). Hoy apunta al centro de Villa Mercedes.
    lat: -33.6757,
    lng: -65.4577,
  },

  hours: [
    { days: "Lunes a viernes", time: "8:00 – 12:30 / 16:00 – 20:00" },
    { days: "Sábados", time: "9:00 – 13:00" },
    { days: "Domingos", time: "Cerrado" },
  ],

  social: {
    facebook: "https://www.facebook.com/RiegoMercedess/",
    instagram: "https://www.instagram.com/riego.mercedes/",
  },

  whatsappMessage:
    "Hola, me contacto desde la web de Riego Mercedes. Quisiera consultar por:",
};

export const addressLine = `${site.address.street}, ${site.address.postalCode} — ${site.address.city} (${site.address.region})`;

export const whatsappUrl = `https://wa.me/${site.phoneRaw}?text=${encodeURIComponent(
  site.whatsappMessage
)}`;

export const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  `${site.address.street}, ${site.address.city}, ${site.address.region}, Argentina`
)}`;

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "Sectores", href: "#sectores" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Proyectos", href: "#proyectos" },
  { label: "Contacto", href: "#contacto" },
];
